import moment from 'moment';

export function formatIsoWeek(date) {
    const value = moment(date);
    return `${value.isoWeekYear()},${value.isoWeek()}`;
}

export function getWeekStartDate(weekValue) {
    return moment(weekValue, "GGGG,WW").startOf('isoWeek');
}

export function getWeekEndDate(weekValue) {
    return moment(weekValue, "GGGG,WW").endOf('isoWeek');
}

export function getWeekDisplayRange(startWeek, endWeek) {
    if (!startWeek || !endWeek) {
        return {
            intervalStartDate: '',
            intervalEndDate: '',
        };
    }

    return {
        intervalStartDate: getWeekStartDate(startWeek).format('YYYY-MM-DD'),
        intervalEndDate: getWeekEndDate(endWeek).format('YYYY-MM-DD'),
    };
}

export function getDefaultWeekInterval() {
    return getPresetWeekInterval('all_time');
}

export function getDefaultCustomWeekInterval() {
    const start = moment().subtract(21, 'd');
    const end = moment();
    return {
        intervalMode: 'custom',
        intervalPreset: 'custom',
        intervalStartWeek: formatIsoWeek(start),
        intervalEndWeek: formatIsoWeek(end),
        ...getWeekDisplayRange(formatIsoWeek(start), formatIsoWeek(end)),
    };
}

export function getPresetWeekInterval(preset) {
    const today = moment();

    if (preset === 'all_time') {
        return {
            intervalMode: 'preset',
            intervalPreset: 'all_time',
            intervalStartWeek: '',
            intervalEndWeek: '',
            intervalStartDate: '',
            intervalEndDate: '',
        };
    }

    let start = moment(today);

    if (preset === 'last_month') {
        start = moment(today).subtract(1, 'month');
    }
    else if (preset === 'last_3_months') {
        start = moment(today).subtract(3, 'months');
    }
    else if (preset === 'last_year') {
        start = moment(today).subtract(1, 'year');
    }
    else if (preset === 'this_year') {
        start = moment(today).startOf('year');
    }
    else {
        return getDefaultCustomWeekInterval();
    }

    const startWeek = formatIsoWeek(start);
    const endWeek = formatIsoWeek(today);

    return {
        intervalMode: 'preset',
        intervalPreset: preset,
        intervalStartWeek: startWeek,
        intervalEndWeek: endWeek,
        ...getWeekDisplayRange(startWeek, endWeek),
    };
}

export function getIntervalLabel({ intervalPreset, intervalStartDate, intervalEndDate }) {
    if (intervalPreset === 'all_time') return 'All time';
    if (intervalStartDate && intervalEndDate) return `${intervalStartDate} - ${intervalEndDate}`;
    return 'All time';
}

export function normalizeWeekRange(startWeek, endWeek) {
    const start = getWeekStartDate(startWeek);
    const end = getWeekStartDate(endWeek);

    if (end.isBefore(start)) {
        return {
            intervalMode: 'custom',
            intervalPreset: 'custom',
            intervalStartWeek: endWeek,
            intervalEndWeek: startWeek,
            ...getWeekDisplayRange(endWeek, startWeek),
        };
    }

    return {
        intervalMode: 'custom',
        intervalPreset: 'custom',
        intervalStartWeek: startWeek,
        intervalEndWeek: endWeek,
        ...getWeekDisplayRange(startWeek, endWeek),
    };
}

export function getCollectedWeekRange(selectedStartWeek, selectedEndWeek, collectedStartWeek, collectedEndWeek) {
    if (!collectedStartWeek || !collectedEndWeek) {
        return null;
    }

    const collectedStart = getWeekStartDate(collectedStartWeek);
    const collectedEnd = getWeekStartDate(collectedEndWeek);

    if (!collectedStart.isValid() || !collectedEnd.isValid() || collectedEnd.isBefore(collectedStart)) {
        return null;
    }

    const selectedStart = selectedStartWeek ? getWeekStartDate(selectedStartWeek) : collectedStart;
    const selectedEnd = selectedEndWeek ? getWeekStartDate(selectedEndWeek) : collectedEnd;
    const effectiveStart = selectedStart.isAfter(collectedStart) ? selectedStart : collectedStart;
    const effectiveEnd = selectedEnd.isBefore(collectedEnd) ? selectedEnd : collectedEnd;

    if (effectiveEnd.isBefore(effectiveStart)) {
        return null;
    }

    return {
        startWeek: formatIsoWeek(effectiveStart),
        endWeek: formatIsoWeek(effectiveEnd),
    };
}
